var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.toggleChatAgent}},[_c('v-list-item-icon',[_c('icon-base',{attrs:{"icon":"custom/ai"}})],1),_c('v-list-item-title',{staticClass:"pr-2"},[_vm._v(" Ask CY ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }